module.exports =
  cart:
    create: '/order/cart/create'
    base: '/order/cart'
    products: '/order/cart/:cartId/products'
    shipping: '/order/cart/:cartId/shipping'
    review: '/order/cart/:cartId/review'
    detail: '/order/cart/:cartId'
    patch: '/order/cart/:cartId/patch'
    quote: '/order/cart/:cartId/quote'
    place: '/order/cart/:cartId/place'
  csv:
    template:  '/order/csv/template.csv'
    upload:  '/order/csv/:cartId/upload'
  order:
    confirm: '/order/:orderId/confirm'
    base: '/order/order'
    shopify: '/order/shopify'
    ecommerce: '/order/ecommerce'
  upload:
    awsPolicy: '/order/upload/awsPolicy'
  artwork:
    render:
      artwork:
        base: '/order/artwork/render.png'
      design:
        base: '/order/artwork/design/:designId/render.png'
      proof:
        base: '/order/artwork/proof/render.png'
        design: '/order/artwork/proof/design/:designId/render.png'

  data:
    validateAddress: '/order/data/validateAddress'
    billing: '/order/data/billing/:billingId'



// WEBPACK FOOTER //
// ./~/oo-routes/routes/order.coffee